import React from 'react';
import { Chip } from '@mui/material';

export interface CountChipProps {
  count: number;
  label: string;
  color?: string;
}

const CountChip: React.FC<CountChipProps> = ({ count, label, color }) => (
  <Chip
    label={`${count} ${label}${count !== 1 ? 's' : ''}`}
    size="small"
    sx={{
      fontWeight: 600,
      color: color ? 'text.white' : 'text.darkgrey',
      backgroundColor: color ?? 'background.grey',
      ...(color ? {} : { border: '1px solid border.default' }),
      // eslint-disable-next-line @typescript-eslint/no-explicit-any
      fontSize: (theme: any) => theme.typography.fontSizes.small,
    }}
  />
);

export default CountChip;
